import {AbstractUserAvatarController} from "./AbstractUserAvatarController";
import {IUserAvatarController} from "./IUserAvatarController";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {Injectable} from "@angular/core";

@Injectable()
export class StandardUserAvatarController extends AbstractUserAvatarController implements IUserAvatarController {

  constructor() {
    super();
  }
}
